import axiosInstance from './axiosConfig';

// authorise amazone account
export const amazoneAccConnect = async () => {
  const response = await axiosInstance.get('/marketplace/amazons/authorize');
  return response.data;
};

// Process amazone account
export const amazoneAccProcess = async (data) => {
  const response = await axiosInstance.post('/marketplace/amazons/exchange_token', data);
  return response.data;
};

// authorise amazone ads account
export const amazoneAdsConnect = async () => {
  const response = await axiosInstance.get('/marketplace/amazon_ads/authorize');
  return response.data;
};

// Process amazone ads account
export const amazoneAdsProcess = async (data) => {
  const response = await axiosInstance.post('/marketplace/amazon_ads/exchange_token', data);
  return response.data;
};

// get marketplaces data account
export const getMarketPlaceAdata = async () => {
  const response = await axiosInstance.get('/marketplaces');
  return response.data;
};

// send Selected Ads Accounts data account
export const sendSelectedAdsAccounts = async (data) => {
  const response = await axiosInstance.put('/marketplace/amazon_ads/select_ads_accounts', data);
  return response.data;
};

